import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Smartphone } from "lucide-react";
import { Reveal } from "./Reveal";
import AppBadges from "./AppBadges";

export default function AppCallout() {
  const appLink =
    (typeof window !== "undefined" ? window.location.origin : "https://svsnursingcollege.com") + "/app";

  return (
    <section className="bg-navy relative overflow-hidden py-20 lg:py-24" data-testid="app-callout">
      <div className="grain-overlay" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-12 items-center">
          <Reveal>
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-gold/15 text-gold text-xs font-mono tracking-[0.2em] uppercase px-4 py-1.5">
                <Smartphone size={14} /> Now on Mobile
              </div>
              <h2 className="font-serif text-4xl sm:text-5xl text-sand mt-5 leading-tight">
                Get the <span className="italic text-gold-gradient">SVS College</span> app
              </h2>
              <p className="text-sand/70 mt-5 max-w-xl leading-relaxed">
                Stay connected on the go — access admissions updates, notices, results, timetables
                and college announcements right from your phone.
              </p>
              <AppBadges className="mt-8" />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex justify-center lg:justify-end">
              <div className="bg-white rounded-2xl p-6 text-center shadow-[0_20px_60px_rgba(0,0,0,0.35)] w-full max-w-[260px]">
                <div className="bg-white p-2 rounded-lg inline-block ring-1 ring-navy/10">
                  <QRCodeCanvas
                    value={appLink}
                    size={180}
                    fgColor="#0A1E4D"
                    bgColor="#ffffff"
                    level="M"
                    includeMargin={false}
                    data-testid="app-qr-code"
                  />
                </div>
                <p className="mt-4 font-serif text-navy text-lg">Scan to download</p>
                <p className="text-navy/50 text-xs mt-1">Opens the right store for your device</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
